import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { RankListResponseWrapper } from '../../api/models';
import { BranchChampionsState } from 'src/app/@core/ngrx/branchchampions/branchchampions.state';
import { isLoading } from 'src/app/@core/ngrx/runningaction/running-action.selectors';
import * as fromBranchChampionsAction from 'src/app/@core/ngrx/branchchampions/branchchampions.actions';
import { selectAllBranchChampionsItemsPresent } from 'src/app/@core/ngrx/branchchampions/branchchampions.selectors';
import { ActivatedRoute } from '@angular/router';
import { ThemeService } from 'src/app/@core/services/theme.service';
import { StringMap } from 'src/app/@core/constants/month-constants';

@Component({
  selector: 'app-championtv-page',
  templateUrl: './championtv-page.component.html',
  styleUrls: ['./championtv-page.component.scss'],
})
export class ChampionTvPageComponent implements OnInit, OnDestroy {
  championsTv$: Observable<RankListResponseWrapper[]> = new Observable();
  branch?: string;
  month: string = '';
  loading$: Observable<boolean> = of(false);
  private interval: any;
  theme: string = '';
  minHeight: string = '700px';

  constructor(
    private store: Store<BranchChampionsState>,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
  ) {}

  ngOnInit() {
    this.loading$ = this.store.pipe(
      select(isLoading([fromBranchChampionsAction.loadMany])),
    );

    const day = String(new Date().getDate()).padStart(2, '0');
    const month = String(new Date().getMonth() + 1).padStart(2, '0');
    const year = new Date().getFullYear();
    this.month = year + '.' + month + '.';
    const longDate = year + '-' + month + '-' + day;

    this.branch = this.activatedRoute.snapshot.url[1].path;

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['color']) {
        this.theme = params['color'];
      } else {
        this.theme = 'light';
      }
      this.themeService.setTheme(this.theme!);

      const htmlEl = document.documentElement;
      document.body.classList.remove('dark-theme', 'light-theme');
      htmlEl.classList.remove('dark-theme', 'light-theme');

      if (this.theme === 'dark') {
        document.body.classList.add('dark-theme');
        htmlEl.classList.add('dark-theme');
      } else {
        document.body.classList.add('light-theme');
        htmlEl.classList.add('light-theme');
      }
    });

    this.store.dispatch(
      fromBranchChampionsAction.loadMany({
        month: longDate,
        nameSpace: this.branch,
      }),
    );

    this.championsTv$ = this.store.pipe(
      select(selectAllBranchChampionsItemsPresent),
    );

    this.interval = setInterval(() => {
      this.reloadPage();
    }, 600000);

    const windowSize = window.innerHeight - 450;
    this.minHeight = windowSize + 'px';
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private reloadPage() {
    const day = String(new Date().getDate()).padStart(2, '0');
    const month = String(new Date().getMonth() + 1).padStart(2, '0');
    const year = new Date().getFullYear();
    const longDate = year + '-' + month + '-' + day;

    this.store.dispatch(
      fromBranchChampionsAction.loadMany({
        month: longDate,
        nameSpace: this.branch!,
      }),
    );
  }

  public onFilterChange(event: StringMap): void {
    const eventDate = new Date(event['month']);
    const year = eventDate.getFullYear();
    const month = String(eventDate.getMonth() + 1).padStart(2, '0');
    const day = String(new Date().getDate()).padStart(2, '0');

    this.month = year + '.' + month + '.';
    const longDate = year + '-' + month + '-' + day;

    this.store.dispatch(
      fromBranchChampionsAction.loadMany({
        month: longDate,
        nameSpace: this.branch!,
      }),
    );

    this.championsTv$ = this.store.pipe(
      select(selectAllBranchChampionsItemsPresent),
    );
  }
}
